import { securedAppApi } from "./securedApi";

const GET_NAVBAR_MENU='NavbarMenu/navbarMenu';
const GET_PAGE_CONFIGURATON='PageConfiguration/pageConfiguraion';
const GET_PAG_PAGE_CONFIGURATION='PageConfiguration/pageConfigurations';
const TAB_META_CONFIGURATION='PageConfiguration/tabMetaDataConfigurations';
const ADD_TABMETA_DATA='PageConfiguration/tabMetaData';
const GET_CARD_META_DATA='PageConfiguration/cardMetaDataConfigurations';
const ADD_CARD_META_DATA='PageConfiguration/cardMetaData';
const GET_MENU_CONFIGURATION='PageConfiguration/menuConfiguration';
const DELETE_PAGE_CONFIGURATION='PageConfiguration/PageConfiguration';
const DELETE_TAB_CONFIGURATION='PageConfiguration/TabMetaData';
const DELETE_CARD_CONFIGURATION='PageConfiguration/CardMetaData';
const ADD_UTILIZE_TEMPLATE_DATA='PageConfiguration/UtilizeTemplateCardMapping';
const GET_PAGE_CONFIGURATION_UTILIZE_TEMPLATES='PageConfiguration/UtilizeTemplateCardMappingByCardId';
const GET_PAGE_CONFIGURATION_UTILIZED='Envelope/GetAllPublishedEnvelopesByCardCategoryName';
const GET_CARD_STATUS_MAPPING='PageConfiguration/EnvelopeAssignmentByStatusCardMapping';
const GET_CARD_STATUS_MAPPING_LCSID='PageConfiguration/StatusCardMappingsByEnvelopAssignementLcsId';
const GET_INDIVIDUAL_ENVELOPEASSIGNMENTS='Envelope/GetAllIndividualEnvelopeAssignmentByTabAndCardIdQuery';
const GET_ENVELOPE_DOCUMENTS_BY_ID='Envelope/GetDocumentsByEnvelopeId';
const DELETE_ENVELOPE_DOCUMENTS_CONFIGURATION='PageConfiguration/EnvelopeAssignmentByStatusCardMapping';
const ADD_ENVELOPE_DOCUMENTS='Envelope/UpdateIndividualEnvelopeAssignmentStatus';
const GET_TAB_ENVELOPES_DATA='PageConfiguration/TabEnvelopStatusConfigByTabId';
const GET_ENVELOPE_SIGNATURES='Envelope/AuthorizeAdminSignatureByEnvelopAndIndividualIds';
const GET_COLOR_META_DATA = 'PageConfiguration/CalendarColorMetaData';
const GET_TIMESHEET_DATES_COLOR_CONFIG = 'PageConfiguration/GetTimesheetDatesColorConfig';
const GET_CARD_META_DATA_BYID='PageConfiguration/CardMetaDataConfigurationsById'
const GET_ALL_ESCALATION_RULE = 'Escalation/GetAllEscalationRule';
const ESCALATION_RULE = 'Escalation/EscalationRule';
const DELETE_ESCALATION_RULE_BY_ID = 'Escalation/DeleteEscalationRuleById';
const ESCALATION_LEVEL = 'References/EscalationLevel';
const UPDATE_NAV_MENUS = 'NavbarMenu/UpdateNavMenus';
const GET_CONFIGURED_ACTIVE_NAVBAR_MENUS = 'NavbarMenu/GetConfiguredActiveNavbarMenus'
const ADD_ROLE_MENU_MAPPING='NavbarMenu/RoleMenuMapping';
const GET_ROLE_MENU_MAPPING='NavbarMenu/GetAllRoleMenuMapping';
const GET_ROLE_MENU_MAPPING_BY_ROLEID='NavbarMenu/RoleMenuMappingByRoleId';

const configuratoinApiHandler=securedAppApi.injectEndpoints({
    endpoints: (builder) => ({
        addNavBarMenu:builder.mutation({
            query:(companydata)=>({
                url:GET_NAVBAR_MENU,
                method:'POST',
                body:companydata
            })
        }),

         UpdateNavMenus:builder.mutation({
            query:(navMenuData)=>({
                url:UPDATE_NAV_MENUS,
                method:'POST',
                body:navMenuData
            })
        }),
        GetNavBarMenu: builder.query({
            query: () =>
                GET_NAVBAR_MENU,
          }),
          addPageConfig:builder.mutation({
            query:(companydata)=>({
                url:GET_PAGE_CONFIGURATON,
                method:'POST',
                body:companydata
            })
        }),
        GetPageConfig: builder.query({
            query: ({menuId}) =>
                GET_PAGE_CONFIGURATON+`?menuId=${menuId}`,
          }),
         GetAllPageConfig:builder.query({
            query:({pageNumber,pageSize,searchString})=>
                GET_PAG_PAGE_CONFIGURATION+`?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
         }),
         GetAllMetaConfiguration:builder.query({
            query:({partyId,pageNumber,pageSize,searchString})=>
                TAB_META_CONFIGURATION+`?involvedPartyRoleTypeId=${partyId}&pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
         }),
         AddMetaDataConfiguration:builder.mutation({
            query:(metaData)=>({
                url:ADD_TABMETA_DATA,
                method:'POST',
                body:metaData
            })
         }),
         GetCardConfiguration:builder.query({
            query:({pageNumber,pageSize,searchString})=>
                GET_CARD_META_DATA+`?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
         }),
         AddCardMetaConfiguration:builder.mutation({
            query:(metaData)=>({
                url:ADD_CARD_META_DATA,
                method:'POST',
                body:metaData
            })
         }),
         GetMenuConfiguration:builder.query({
            query:({menuid})=>
                GET_MENU_CONFIGURATION+`?menuId=${menuid}`
         }),
         DeleteNavBarMenu: builder.mutation({
            query: (teamMember: string) => ({
              url: `${GET_NAVBAR_MENU}/${teamMember}`,
              method: 'DELETE',
            }),
          }),
          DeletePageConfiguration: builder.mutation({
            query: (teamMember: string) => ({
              url: `${DELETE_PAGE_CONFIGURATION}/${teamMember}`,
              method: 'DELETE',
            }),
          }),
          DeleteTabMetaData: builder.mutation({
            query: (teamMember: string) => ({
              url: `${DELETE_TAB_CONFIGURATION}/${teamMember}`,
              method: 'DELETE',
            }),
          }),
          DeleteCardConfiguration: builder.mutation({
            query: (teamMember: string) => ({
              url: `${DELETE_CARD_CONFIGURATION}/${teamMember}`,
              method: 'DELETE',
            }),
          }),
          AddUtilizeTemplateData:builder.mutation({
            query:(metaData)=>({
                url:ADD_UTILIZE_TEMPLATE_DATA,
                method:'POST',
                body:metaData
            })
          }),
          GetUtilizeTemplateData:builder.query({
            query:({pageNumber,pageSize})=>
                ADD_UTILIZE_TEMPLATE_DATA+`?pageNumber=${pageNumber}&pageSize=${pageSize}`
          }),
          DeleteUtilzeTemplateData: builder.mutation({
            query: (teamMember: string) => ({
              url: `${ADD_UTILIZE_TEMPLATE_DATA}/${teamMember}`,
              method: 'DELETE',
            }),
          }),
          GetPageConfigurationUtilized:builder.query({
            query:({cardiD})=>
              GET_PAGE_CONFIGURATION_UTILIZE_TEMPLATES+`/${cardiD}`
          }),
          GetPageConfigurationUtilizedDocuments:builder.query({
            query:({pageNumber,pageSize,CardName, searchString})=>
              GET_PAGE_CONFIGURATION_UTILIZED+`?pageNumber=${pageNumber}&pageSize=${pageSize}&CardName=${CardName}&searchString=${searchString}`

          }),
          AddEnvelopeAssignmentByStatus:builder.mutation({
            query:(metaData)=>({
                url:GET_CARD_STATUS_MAPPING,
                method:'POST',
                body:metaData
            })
         }),
         GetEnvelopeAssignmentByStatus:builder.query({
          query:({id,pageNumber,pageSize})=>
            GET_CARD_STATUS_MAPPING_LCSID+`/${id}?pageNumber=${pageNumber}&pageSize=${pageSize}`
         }),
         GetIssuedEnvelopeDocuments:builder.query({
          query:({CardId,TabId,signature,pageNumber,pageSize,searchString})=>
            GET_INDIVIDUAL_ENVELOPEASSIGNMENTS+`/${CardId}/${TabId}/${signature}?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
         }),
         GetDocumentsByEnvelopeId:builder.query({
          query:({id})=>
            GET_ENVELOPE_DOCUMENTS_BY_ID+`/${id}`
         }),
         DeleteEnvelopeAssignmentStatusCard: builder.mutation({
          query: (teamMember: string) => ({
            url: `${DELETE_ENVELOPE_DOCUMENTS_CONFIGURATION}/${teamMember}`,
            method: 'DELETE',
          }),
        }),
        UpdateEnvelopeCycleStatusData:builder.mutation({
          query:(metaData)=>({
              url:ADD_ENVELOPE_DOCUMENTS,
              method:'POST',
              body:metaData
          })
        }),
        GetTabsEnvelopeStatusConfigData:builder.query({
          query:({id})=>
            GET_TAB_ENVELOPES_DATA+`/${id}`
        }),
        UpdateEnvelopeStatusbySignatureData:builder.mutation({
          query:(metaData)=>({
            url:GET_ENVELOPE_SIGNATURES,
                method:'POST',
                body:metaData
          })
        }),

        GetCalendarColorMetaData:builder.query({
          query:()=>
            GET_COLOR_META_DATA
        }),

        UpdateCalendarColorMetaData:builder.mutation({
          query:(metaData)=>({
            url:GET_COLOR_META_DATA,
                method:'POST',
                body:metaData
          })
        }),
        GetCardMetaDataById:builder.query({
          query:({cardiD})=>
            GET_CARD_META_DATA_BYID+`/${cardiD}`
        }),
        GetTimesheetDatesColorConfig:builder.query({
          query:()=>
            GET_TIMESHEET_DATES_COLOR_CONFIG
        }),

        GetAllEscalationRule:builder.query({
          query:({pageNumber,pageSize,searchString})=>
            GET_ALL_ESCALATION_RULE+`?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
       }),

       addEscalationRule:builder.mutation({
        query:(metaData)=>({
          url:ESCALATION_RULE,
              method:'POST',
              body:metaData
        })
      }),

      DeleteEscalationRuleById: builder.mutation({
        query: (data: string) => ({
          url: `${DELETE_ESCALATION_RULE_BY_ID}/${data}`,
          method: 'DELETE',
        }),
      }),

      AddEscalationLevel:builder.mutation({
        query:(metaData)=>({
            url:ESCALATION_LEVEL,
            method:'POST',
            body:metaData
        })
      }),
      GetEscalationLevel:builder.query({
        query:({pageNumber,pageSize,searchString})=>
          ESCALATION_LEVEL+`?pageNumber=${pageNumber}&pageSize=${pageSize}&searchString=${searchString}`
      }),
      DeleteEscalationLevel: builder.mutation({
        query: (teamMember: string) => ({
          url: `${ESCALATION_LEVEL}/${teamMember}`,
          method: 'DELETE',
        }),
      }),
            AddRoleMenuMapping:builder.mutation({
        query:(metaData)=>({
            url:ADD_ROLE_MENU_MAPPING,
            method:'POST',
            body:metaData
        })
      }),
      GetRoleMenuMapping:builder.query({
        query:({pageNumber,pageSize})=>
          GET_ROLE_MENU_MAPPING+`?pageNumber=${pageNumber}&pageSize=${pageSize}`
      }),
      GetRoleMenuMappingByRoleId:builder.query({
          query:({id})=>
            GET_ROLE_MENU_MAPPING_BY_ROLEID+`/${id}`
        }),
        GetConfiguredActiveNavbarMenus: builder.query({
            query: () =>
                GET_CONFIGURED_ACTIVE_NAVBAR_MENUS,
          }),

    })
});

export const {useAddNavBarMenuMutation,useGetNavBarMenuQuery,useAddPageConfigMutation,useGetPageConfigQuery,useGetAllPageConfigQuery,useGetAllMetaConfigurationQuery,useAddMetaDataConfigurationMutation,useGetCardConfigurationQuery,useAddCardMetaConfigurationMutation,useGetMenuConfigurationQuery,useDeleteNavBarMenuMutation,useDeletePageConfigurationMutation,useDeleteTabMetaDataMutation,useDeleteCardConfigurationMutation,useAddUtilizeTemplateDataMutation,useGetUtilizeTemplateDataQuery,useDeleteUtilzeTemplateDataMutation,useGetPageConfigurationUtilizedQuery,useGetPageConfigurationUtilizedDocumentsQuery,useAddEnvelopeAssignmentByStatusMutation,useGetEnvelopeAssignmentByStatusQuery
  ,useGetIssuedEnvelopeDocumentsQuery,useGetDocumentsByEnvelopeIdQuery,useDeleteEnvelopeAssignmentStatusCardMutation,useUpdateEnvelopeCycleStatusDataMutation,useGetTabsEnvelopeStatusConfigDataQuery,useUpdateEnvelopeStatusbySignatureDataMutation,
  useGetCalendarColorMetaDataQuery, useUpdateCalendarColorMetaDataMutation,
  useGetTimesheetDatesColorConfigQuery,useGetCardMetaDataByIdQuery, useAddEscalationRuleMutation,
   useDeleteEscalationRuleByIdMutation, useGetAllEscalationRuleQuery,
   useAddEscalationLevelMutation, useDeleteEscalationLevelMutation, useGetEscalationLevelQuery, useUpdateNavMenusMutation, useGetConfiguredActiveNavbarMenusQuery,
   useAddRoleMenuMappingMutation,useGetRoleMenuMappingByRoleIdQuery,useGetRoleMenuMappingQuery
}=configuratoinApiHandler;
export default configuratoinApiHandler.reducer;
